import { render, staticRenderFns } from "./block-inputs-new.vue?vue&type=template&id=6f2ae714&scoped=true&"
import script from "./block-inputs-new.vue?vue&type=script&lang=ts&"
export * from "./block-inputs-new.vue?vue&type=script&lang=ts&"
import style0 from "./block-inputs-new.vue?vue&type=style&index=0&id=6f2ae714&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2ae714",
  null
  
)

export default component.exports